import styled from '@emotion/styled';
import { boxSizes, fontSizes, lineHeights, colors, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const QuoteServiceFormContainer = styled.div`
    height: calc(100% - 48px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h2 {
        font-size: ${fontSizes.pgLarge};
        line-height: ${lineHeights.xlarge};
        color: ${colors.bark};
        margin-bottom: ${gutterSizes.large};
    }

    .search-bar > input {
        box-sizing: border-box;
        height: ${boxSizes.boxHeight};
        margin-right: 0;
        width: 100%;
        outline: none;
    }
`;
